import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { CurrentUserService } from 'services/currentUser';
import { HippoApiService } from 'services/hippoApi';
import * as _ from 'lodash';
import { IAugmentedJQuery, IRootScopeService, ITimeoutService } from 'angular';
import { PermissionService } from 'services/permission';

const module = angular.module('escrow-payment-method', []);

interface EscrowPaymentMethodController extends angular.IStrictController {
    cancel: () => void;
    save: () => void;
    edit: () => void;
    isEditMode: boolean;
    canCancelEditMode: boolean;
    lenderName?: string;
    loanNumber?: string;
    policyInfo: CustomerPolicyInfo;
    showEditPaymentButton: boolean;
    escrowDetails: EscrowDetails;
}

const emptyEscrowDetails = {
    loan_officer_fullname: '',
    loan_number: '',
    lender_name: '',
    lender_mailing_address: {
        city: '',
        state: '',
        street: '',
        street2: '',
        zip: ''
    }
};

module.component('escrowPaymentMethod', {
    bindings: {
        policyInfo: '<',
        onPaymentMethodChange: '&'
    },
    template: template,
    controller: function(
        this: EscrowPaymentMethodController,
        $stateParams: StateParams,
        currentUserService: CurrentUserService,
        hippoApiService: HippoApiService,
        $element: IAugmentedJQuery,
        $rootScope: IRootScopeService,
        $scope: angular.IScope,
        $timeout: ITimeoutService,
        permissionService: PermissionService
    ) {
        const updateDisplay = () => {
            this.loanNumber = this.policyInfo.checkout_data.loan_number;
            this.lenderName = this.policyInfo.checkout_data.lender_name;
            this.isEditMode = !this.loanNumber && !this.lenderName;
            this.canCancelEditMode = !this.isEditMode;
            this.showEditPaymentButton = permissionService.canEditPaymentMethod(this.policyInfo);
            this.escrowDetails = {
                ...emptyEscrowDetails,
                lender_mailing_address: {
                    ...this.policyInfo.checkout_data.lender_mailing_address
                } as LenderMailingAddress,
                lender_name: this.lenderName || '',
                loan_number: this.loanNumber || ''
            };
        };

        this.$onInit = () => {
            updateDisplay();
        };

        this.$onChanges = (changesObj) => {
            const policyInfo = changesObj.policyInfo;
            if (policyInfo && policyInfo.currentValue !== undefined) {
                $timeout(() => {
                    this.policyInfo = policyInfo.currentValue;
                    updateDisplay();
                });
            }
        };

        this.cancel = () => {
            $scope.$emit('closePaymentEditSection');
        };

        this.save = () => {
            const policyId = this.policyInfo.id;
            const policyInfoUpdate: CustomerPolicyInfoUpdate = {
                checkout_data: {
                    payment_method: 'escrow',
                    lender_mailing_address: {
                        ...this.escrowDetails.lender_mailing_address
                    },
                    lender_name: this.escrowDetails.lender_name,
                    loan_number: this.escrowDetails.loan_number
                }
            };
            hippoApiService.updateCustomerPolicy(policyId, policyInfoUpdate).then(
                function success() {
                    currentUserService.getUpdatedCustomerPolicyInfos().then(() => {
                        $rootScope.$emit('updatedCustomerPolicyInfos');
                        $rootScope.$emit('paymentMethodUpdateSuccess', 'escrow');
                        $scope.$emit('closePaymentEditSection');
                    });
                },
                function error() {}
            );
        };
    }
});

export { module };
